import { Field, Input } from '@fluentui/react-components';
import React, { memo, useCallback, useMemo } from 'react';
import { fieldMeetCertainCriteriaStyles } from '../styles';
import { useAutomationRuleConditions } from '../../use-conditions';
import { ConditionItemType, FieldMeetCertainCriteriaType } from '../../types';

interface Props {
  id?: string;
  conditionId: string;
  validationError: string | null;
  type?: 'number'| 'text';
}

function TextInputComponent(props: Props) {
	const classes = fieldMeetCertainCriteriaStyles();
	const {conditions, setConditions, resetValidationErrors} = useAutomationRuleConditions();

	const current: FieldMeetCertainCriteriaType = useMemo(() => {
		const foundConditions = conditions.find(item => item.id === props.conditionId) as ConditionItemType;
		return foundConditions!.fieldMeetCertainCriteria as FieldMeetCertainCriteriaType;
	}, [conditions, props.conditionId]);

	const onChangeText = useCallback((value: string) => {
		resetValidationErrors();
		setConditions((oldValues) => {
			return oldValues.map((item) => {
				if (item.id === props.conditionId) {
					const fieldMeetCertainCriteriaValues = item!.fieldMeetCertainCriteria as FieldMeetCertainCriteriaType;
					return {
						...item,
						fieldMeetCertainCriteria: {
							...fieldMeetCertainCriteriaValues,
							textValue: value,
						}
					};
				}

				return {
					...item,
				};
			});
		});
	}, [props.conditionId]);

	return (
		<Field
			className={classes.dropdownRoot}
			validationMessage={props.validationError}
		>
			<Input
				type={props.type}
				autoComplete='off'
				appearance='outline'
				className={classes.input}
				placeholder='Enter a value'
				value={current.textValue}
				onChange={(_, data) => {
					onChangeText(data.value);
				}}
			/>
		</Field>
	);
}

const TextInput = memo(TextInputComponent);
export default TextInput;